/* js/components/MapPointerButton.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	src_url_equal,
	stop_propagation
} from "svelte/internal";

import { appRouter } from '../appRouter.js';
import { createEventDispatcher } from 'svelte';

function create_else_block(ctx) {
	let img;
	let img_src_value;
	let mounted;
	let dispose;

	return {
		c() {
			img = element("img");
			attr(img, "class", "shadow svelte-1nr0brc");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath('/_icons/Center_Me-02.svg'))) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);

			if (!mounted) {
				dispose = listen(img, "click", stop_propagation(/*onClick*/ ctx[1]));
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(img);
			mounted = false;
			dispose();
		}
	};
}

// (20:4) {#if active}
function create_if_block(ctx) {
	let img;
	let img_src_value;
	let mounted;
	let dispose;

	return {
		c() {
			img = element("img");
			attr(img, "class", "shadow svelte-1nr0brc");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath('/_icons/Center_Me-03.svg'))) attr(img, "src", img_src_value);
		},
		m(target, anchor) {
			insert(target, img, anchor);

			if (!mounted) {
				dispose = listen(img, "click", stop_propagation(/*onClick*/ ctx[1]));
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(img);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if (/*active*/ ctx[0]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "_root svelte-1nr0brc");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const dispatchEvent = createEventDispatcher();
	let { active = false } = $$props;

	// $: console.log("pointer active state is", active);
	function onClick() {
		$$invalidate(0, active = !active);
		dispatchEvent('statuschange', { status: active });
	}

	$$self.$$set = $$props => {
		if ('active' in $$props) $$invalidate(0, active = $$props.active);
	};

	return [active, onClick];
}

class MapPointerButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { active: 0 });
	}
}

export default MapPointerButton;